import {
	Component,
	EventEmitter,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { AccountServiceWebProvider } from '@web-services/user/account.service';

@Component({
	selector: 'terms-updated-modal',
	template: require('./terms-updated-modal.html'),
	styles: [require('./terms-updated-modal.scss')]
})
export class TermsUpdatedModalComponent implements OnInit, OnDestroy {
	@Output() onDisagree: EventEmitter<any> = new EventEmitter();
	@Output() onAgree: EventEmitter<any> = new EventEmitter();

	button_disable: boolean;
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(private accountService: AccountServiceWebProvider) {}

	ngOnInit() {}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	logout(): void {
		this.accountService.logoutWeb();
	}

	agree(): void {
		this.onAgree.emit();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/terms-updated-modal/terms-updated-modal.ts